// extracted by mini-css-extract-plugin
export default {"root":"jJ0Epfx4","outlet":"EigawNLR"};